$('.product-opportunities-radio').on('change', function (e){
    let id = e.target.value
    $.ajax({
        type: 'GET',
        url: `/api/v1/crm/opportunity/${id}`,
        headers: {
            "x-localization": $('html').attr('lang'),
        }
    }).done(function (response) {
        $('.product-opportunities-content-container').html("");
        $('.product-opportunities-content-container').append(response.data)
    }).fail(function (error) {
    });
})
$('#opportunity').on('select2:select', function (e) {
    let id = e.params.data.id;
    $.ajax({
        type: 'GET',
        url: `/api/v1/crm/opportunity/${id}`,
        headers: {
            "x-localization": $('html').attr('lang'),
        }
    }).done(function (response) {
        $('.product-opportunities-content-container').html("");
        $('.product-opportunities-content-container').append(response.data)
    }).fail(function (error) {
    });
})
if(document.getElementById('tell')){
    $('#opportunity').select2({
        dropdownCssClass: "opportunity-drop-blue",
        minimumResultsForSearch: -1,
    });
} else {
    $('#opportunity').select2({
        dropdownCssClass: "opportunity-drop",
        minimumResultsForSearch: -1,
    });
}
